import React from 'react';
import * as Styles from './pricing.styled';
import { truncatedZeroPencePrice } from '@at/formatter-utils/lib/number-utils/number.utils';
import { TypeMini, TypePrius } from '@at/design-system-foundation';
import { BadgeGroup, BadgeCategories } from '@at/design-system-elements';
import { SROnly } from '../vehicle-card.styled';
export var PricingNew = function (_a) {
    var rrp = _a.rrp, saving = _a.saving, price = _a.price;
    var displayPrice = price && typeof price === 'number' ? truncatedZeroPencePrice(price) : price;
    var displayRRP = rrp ? truncatedZeroPencePrice(rrp) : undefined;
    var displaySaving = saving ? truncatedZeroPencePrice(saving) : undefined;
    return (React.createElement(React.Fragment, null,
        displayRRP && (React.createElement(Styles.VehicleCardPriceRRP, null,
            React.createElement(TypeMini, null, "MRRP"),
            React.createElement(SROnly, null, "Manufacturer's Recommended Retail Price"),
            React.createElement(TypePrius, null, displayRRP))),
        React.createElement("div", null,
            React.createElement(Styles.VehicleCardPriceIntro, { as: "p" }, "Now"),
            displayPrice && React.createElement(Styles.VehicleCardPriceLower, { as: "p" }, displayPrice)),
        displaySaving && (React.createElement(Styles.VehicleCardPriceSaving, null,
            React.createElement(TypeMini, null, "Save"),
            React.createElement(BadgeGroup, { content: [
                    {
                        category: BadgeCategories.saving,
                        text: displaySaving,
                    },
                ] })))));
};
